import { useEffect } from 'react';

/**
 * Applies the calm bedtime presentation (spec §8.4, F19).
 *
 * The palette swap lives entirely in CSS custom properties under
 * `:root[data-mood="bedtime"]`, so nothing re-renders and no component needs a
 * bedtime branch. Optional effects read `useBedtimeActive()` and simply do not
 * render.
 *
 * It is only ever turned on by a parent choosing it — the app never decides on
 * its own that it is bedtime, and it never schedules anything.
 */
export function useBedtime(active: boolean) {
  useEffect(() => {
    const root = document.documentElement;
    if (active) root.dataset.mood = 'bedtime';
    else delete root.dataset.mood;
    return () => {
      delete root.dataset.mood;
    };
  }, [active]);
}

/** True while the bedtime presentation is applied. */
export function bedtimeActive(): boolean {
  return typeof document !== 'undefined' && document.documentElement.dataset.mood === 'bedtime';
}
